import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

import { useQuery } from "react-query";

export function useCustomers() {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: "customers",
    queryFn: async () => {
      return await apiContext.customerApis.getCustomers();
    },
  });
}
